'use client';
/** @jsxImportSource @emotion/react */

import type { ToggleButtonGroupProps as MuiToggleButtonGroupProps } from '@mui/material/ToggleButtonGroup';

import MuiToggleButtonGroup from '@mui/material/ToggleButtonGroup';

type ExcludedMuiProps = '';

interface ToggleButtonGroupProps
  extends Omit<MuiToggleButtonGroupProps, ExcludedMuiProps> {
  component?: React.ElementType;
}

export type { ToggleButtonGroupProps };

export const ToggleButtonGroup: React.FC<ToggleButtonGroupProps> =
  MuiToggleButtonGroup;

ToggleButtonGroup.displayName = 'ToggleButtonGroup';
